import type { AppType } from "@modbot/api/app";
import { hc } from "hono/client";

/** Typed RPC client; shapes come straight from the Hono route definitions. */
export const api = hc<AppType>("/api", { init: { credentials: "same-origin" } });

export class ApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
  ) {
    super(message);
  }
}

/** Throw on non-2xx so TanStack Query sees failures; returns the typed body. */
export async function unwrap<R extends { ok: boolean; status: number; json(): Promise<unknown> }>(
  res: R,
): Promise<Awaited<ReturnType<R["json"]>>> {
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new ApiError(res.status, body.error ?? `HTTP ${res.status}`);
  }
  return (await res.json()) as Awaited<ReturnType<R["json"]>>;
}
